import { p as proxyCustomElement, H, h, d as Host } from './p-BJEvNVLM.js';

const cosmosIconCss = ":host{color:var(--cosmos-icon-color, inherit);display:inline-block;height:var(--cosmos-icon-size, 1em);vertical-align:-0.1551724138em;width:var(--cosmos-icon-size, 1em)}svg,::slotted(svg){display:block;height:100%;width:100%}";

const CosmosIconWarning = /*@__PURE__*/ proxyCustomElement(class CosmosIconWarning extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
    }
    getRole() {
        return this.ariaLabel ? 'img' : undefined;
    }
    getAriaHidden() {
        return this.ariaLabel ? false : 'true';
    }
    render() {
        return (h(Host, { key: '97c24faa640ae7a4309fead380a6b1ce089d42a3', role: this.getRole(), "aria-hidden": this.getAriaHidden(), "aria-label": this.ariaLabel }, h("svg", { key: '98081b14117f8578e2d21390c6cd2f991f4049f2', width: "22", height: "22", viewBox: "0 0 22 22", fill: "none", xmlns: "http://www.w3.org/2000/svg", part: "base" }, h("path", { key: 'a5875811bfe7159928e6ce62b279d693ef9de2c6', "fill-rule": "evenodd", "clip-rule": "evenodd", d: "M19.57 17.25 11.43 3.11a.49.49 0 0 0-.86 0L2.44 17.25a.5.5 0 0 0 .43.75h16.27a.5.5 0 0 0 .43-.75M10.25 9.5a.5.5 0 0 1 .5-.5h.5a.5.5 0 0 1 .5.5v3a.5.5 0 0 1-.5.5h-.5a.5.5 0 0 1-.5-.5zM11 16a1 1 0 1 1 0-2 1 1 0 0 1 0 2", fill: "currentColor" }))));
    }
    static get style() { return cosmosIconCss; }
}, [1, "cosmos-icon-warning", {
        "ariaLabel": [513, "aria-label"]
    }]);
function defineCustomElement() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-icon-warning"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-icon-warning":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosIconWarning);
            }
            break;
    } });
}

export { CosmosIconWarning as C, defineCustomElement as d };
